import React, { useEffect, useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Topbar, GameAlert, } from '@components';
import styled from 'styled-components';
import { PUBLIC_ROUTE } from '@router/route.constants';
import { useSelector } from 'react-redux';
import ExitConfirmModal from './ExitConfirmModal/ExitConfirmModal';
import { useGame } from '@hooks';
import { Status } from '@api';

const RootContainer = styled.div`
width: 100vw;
position: absolute;
left: 0;
top: 0;
`;

const IFrame = styled.iframe.attrs({
    id: 'panda-iframe'
})`
width: 100vw;
height: calc(100vh - 70px);
overflow: hidden;
`;

const InGame = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { url, game } = state || {};
    const { exitGame } = useGame();

    const { gameExitStatus, prevRoute } = useSelector(state => state.game);
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        requestFullscreen();

        return () => {
            !loading && exitGame();
        }

        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (
            gameExitStatus === Status.SUCCESS ||
            (gameExitStatus === Status.ERROR && loading)
        ) {
            setLoading(false);
            goBack();
        }

        // eslint-disable-next-line
    }, [gameExitStatus]);

    const requestFullscreen = () => {
        try {
            let elem = document.getElementById('panda-iframe');
            if (elem.requestFullscreen) {
                elem.requestFullscreen().catch(() => { });

            } else if (elem.webkitRequestFullscreen) { /* Safari */
                elem.webkitRequestFullscreen().catch(() => { });

            } else if (elem.msRequestFullscreen) { /* IE11 */
                elem.msRequestFullscreen().catch(() => { });
            }
        } catch {
            console.log('Fullscreen request failed!');
        }
    }

    const onOk = () => {
        if (!loading) {
            setLoading(true);
            exitGame();
        }
    }

    const onCancel = () => {
        !loading && setOpen(false);
    }

    const handleGoBack = () => {
        setOpen(true);
    }

    const goBack = () => {
        navigate(prevRoute);
    }

    if (!state) {
        return <Navigate to={`/${PUBLIC_ROUTE.HOME}`} />
    }

    return (
        <>
            <RootContainer>
                <Topbar
                    title={game.name}
                    goBack={handleGoBack}
                />
                <IFrame src={url} allowFullScreen={true} />
            </RootContainer>
            <GameAlert />
            <ExitConfirmModal
                open={open}
                confirmLoading={loading}
                gameIcon={game.icon}
                onCancel={onCancel}
                onOk={onOk}
            />
        </>
    );
}

export default InGame;